<template>
    <b-card no-body>
        <div slot="header">{{ $t('emailaddresses') }}</div>

        <b-list-group flush>
            <!-- Email address list -->
            <b-list-group-item
                class="hoverable-list-group-item"
                v-for="email in emailAddresslist"
                :key="email.id"
            >
                <span>{{ email.email }}</span>

                <a-popconfirm
                    :title="$t('confirm.delete')"
                    @confirm="removeEmail(email)"
                    v-if="editEnabled && !email.primary"
                >
                    <a-button
                        type="danger"
                        class="pull-right"
                        size="small"
                        shape="circle"
                        :title="$t('label.confirm')"
                    >
                        <i class="fa fa-trash" />
                    </a-button>
                </a-popconfirm>
            </b-list-group-item>

            <!-- Add email button -->
            <b-list-group-item v-if="!showAddEmailInput && editEnabled">
                <b-btn
                    block
                    variant="ghost-primary"
                    @click="showAddEmailInput = true"
                >
                    <i class="fa fa-plus" />
                    {{ $t('text.addEmailAddress') }}
                </b-btn>
            </b-list-group-item>
            <!-- Add email input -->
            <b-list-group-item v-if="showAddEmailInput && editEnabled">
                <b-input-group>
                    <b-input v-model="prefix" />

                    <b-input-group-addon>
                        <b-btn disabled>@</b-btn>
                        <b-dropdown
                            :text="suffix ? suffix.postfix : ''"
                            variant="default"
                            slot="append"
                        >
                            <b-dropdown-item
                                v-for="s in visibleSuffixes"
                                :key="s.id"
                                @click="setSuffix(s)"
                                >{{ s.postfix }}</b-dropdown-item
                            >
                        </b-dropdown>

                        <b-btn variant="success" @click="addEmail">{{
                            $t('label.add')
                        }}</b-btn>
                        <b-btn
                            variant="danger"
                            @click="showAddEmailInput = false"
                            >{{ $t('label.cancel') }}</b-btn
                        >
                    </b-input-group-addon>
                </b-input-group>
            </b-list-group-item>
        </b-list-group>
    </b-card>
</template>

<script>
import sortBy from 'lodash/sortBy'
export default {
    props: {
        user: {
            required: true,
        },
        editEnabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            emailAddresses: this.$resource('emailaddresses'),
            showAddEmailInput: false,
            prefix: '',
            suffix: '',
            suffixes: this.$resource('emailPostfixes'),
            newEmailAddress: this.$resource('emailaddresses'),
        }
    },

    created() {
        this.getAvailableSuffixes()
        this.getEmailAddresses()
        // console.log('suffixes', this.suffixes)
    },

    computed: {
        visibleSuffixes() {
            return this.suffixes.models
        },

        emailAddresslist() {
            return sortBy(this.emailAddresses.models, [
                o => !o.primary,
                'email',
            ])
        },
    },

    methods: {
        setSuffix(suffix) {
            this.suffix = suffix
        },

        removeEmail(email) {
            console.log(email)
            email.delete().then(() => {
                setTimeout(this.getEmailAddresses, 500)
            })
        },

        addEmail() {
            let suffix = JSON.parse(JSON.stringify(this.suffix))

            let rq = {
                employee_id: this.user.id,
                email_postfix_id: suffix.id,
                email: this.prefix + '@' + suffix.postfix,
                suffix,
            }

            this.showAddEmailInput = false
            this.newEmailAddress = this.$resource('emailaddresses', rq)
            this.newEmailAddress
                .save()
                .then(() => {
                    this.getEmailAddresses()
                    this.prefix = ''
                })
                .catch(() => {
                    alert('Det skjedde en feil.')
                })
        },

        getEmailAddresses() {
            this.emailAddresses.setFilter({
                employee_id: this.user.id,
            })
            this.emailAddresses.fetch().then(console.log)
        },

        getAvailableSuffixes() {
            this.suffixes.setFilter({
                company_id: this.user.company_id,
            })
            this.suffixes.on('fetch', () => {
                this.suffix = this.suffixes.models[0]
            })

            this.suffixes.fetch()
        },
    },
}
</script>
<style scoped>
.hoverable-list-group-item:hover {
    background: #eee;
}
</style>
